import { breakpoints } from '@bnnvara/breakpoints';
import { BaseButton } from '@bnnvara/buttons';
import { Subtitle } from '@bnnvara/typography';
import { animated } from 'react-spring';
import styled from 'styled-components';

export const Menu = styled.section`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.tertiary.main};
  height: 100%;
  width: 100%;
  position: relative;

  ${breakpoints.md} {
    flex-direction: row;
  }
`;

export const LabelWrapper = styled.span`
  text-align: left;
  width: 100%;
  display: block;
  padding: 16px 0;

  svg {
    float: right;
    width: 30px;
    height: 30px;
  }

  ${breakpoints.lg} {
    width: 90%;
    margin-left: 50px;
  }
`;

export const BlockOne = styled.div`
  flex: 1;
  background: ${({ theme }) => theme.base.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const BlockTwo = styled.div`
  position: relative;
  flex: 3;
`;

export const StyledMenuChevron = styled.span`
  svg {
    width: 40px;
    height: 40px;
    margin: -10px 10px;
  }
  right: 0;
`;

export const MenuItemContainer = styled(animated.div)`
  text-align: left;
`;

export const TabsButton = styled(BaseButton, {
  variant: 'menu',
})`
  font-size: 28px;
  display: inline-block;
  font-weight: 1000;

  ${breakpoints.md} {
    font-size: 36px;
  }
`;

export const HomeButton = styled(BaseButton, {
  variant: 'text',
})`
  font-size: 28px;
  display: block;
  width: fit-content;
  font-weight: 1000;
  margin-left: 24px;
  margin-bottom: 16px;
  margin-top: 40px;

  ${breakpoints.md} {
    margin-left: 24px;
    font-size: 36px;
  }

  ${breakpoints.lg} {
    margin-bottom: 24px;
    margin-left: 80px;
  }
`;

export const SubscribeButton = styled(BaseButton)`
  position: relative;
  margin: 2vh 7vw;
  display: inline-flex;

  ${breakpoints.md} {
    margin: 5vh 7vw;
  }

  svg {
    left: 100%;
    margin-left: 10px;
  }
`;

export const TopContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 10vh;

  ${breakpoints.md} {
    margin-top: 10vh;
    display: block;
    justify-content: center;
  }
`;

export const SubMenu = styled(animated.div)`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.tertiary.main};
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  ${breakpoints.md} {
    position: absolute;
    background: transparent;
  }

  > div {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 3vh 7vw;

    ${breakpoints.md} {
      padding: 12vh 7vw;
    }
  }

  h2 {
    margin-bottom: 6vh;
    font-weight: 700;

    ${breakpoints.md} {
      margin-bottom: 9vh;
      font-size: 18px;
    }
  }
`;

export const SubMenuList = styled.ol`
  list-style: none;
  margin-bottom: 5vh;
`;

export const SubMenuLink = styled.a`
  font-family: ${({ theme }) => theme.fonts.primary};
  text-transform: initial;
  margin-bottom: 6vh;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 100%;
  width: auto;
  font-weight: 700;
  color: ${({ theme }) => theme.base.black};
  text-decoration: none;
  background-color: transparent;
  position: relative;
  padding: 0;
  border: 0;

  ${breakpoints.md} {
    font-size: 24px;
    margin-bottom: 8vh;
  }

  &:visited {
    color: ${({ theme }) => theme.base.black};
  }

  &:after {
    content: '';
    display: block;
    height: 4px;
    width: 100%;
    background-color: ${({ theme }) => theme.primary.main};
    position: absolute;
    bottom: -6px;
    left: 0;
    transform: scaleX(0);
    transform-origin: left center;
    transition: all 0.2s ease-in-out;
  }

  @media (pointer: fine) {
    &:hover {
      &:after {
        transform: scaleX(1);
        transform-origin: left center;
      }
    }
  }
`;

export const SubMenuOverviewLink = styled(SubMenuLink)`
  margin-bottom: 11vh;

  ${breakpoints.md} {
    margin-bottom: 13vh;
  }

  > svg {
    position: relative;
  }
`;

export const SubMenuSubtitle = styled(Subtitle)`
  color: ${({ theme }) => theme.tertiary.dark};
  margin-bottom: 16vh;
`;
